import * as service from './service'
export default {
  namespace: 'recruitInfoCollection',
  state: {
    formState: {
      cityName: {
        value: ''
      },
      name: {
        value: ''
      },
      mobile: {
        value: ''
      },
      captchaInfo: {
        value: ''
      }
    }
  },
  effects: {
    * cities ({ payload }, { call }) {
      return yield call(service.cities, { payload })
    },
    * sendSmsCode ({ payload }, { call }) {
      return yield call(service.sendSmsCode, payload)
    },
    * getCodeBySms ({ payload }, { call }) {
      return yield call(service.getCodeBySms, payload)
    },
    * preferSubmit ({ payload }, { call }) {
      return yield call(service.preferSubmit, { payload })
    },
    * courierAge ({ payload }, { call, put }) {
      try {
        const res = yield call(service.courierAge, payload)
        const { data, status } = res.data
        if (status === 200) {
          return data
        } else {
          return Promise.reject()
        }
      } catch (error) {
        return Promise.reject()
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    },
    save_fields (state, { payload }) {
      return {
        ...state,
        formState: {
          ...state.formState,
          ...payload
        }
      }
    }
  }
}
